import gql from 'graphql-tag';

export default gql`
  fragment workflowProspectPoolFragment on WorkflowProspectPool {
    id
    status
    statusText
  }
`;
